import { render, staticRenderFns } from "./Selected.vue?vue&type=template&id=2c49de52&scoped=true&"
import script from "./Selected.vue?vue&type=script&lang=js&"
export * from "./Selected.vue?vue&type=script&lang=js&"
import style0 from "./Selected.vue?vue&type=style&index=0&id=2c49de52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49de52",
  null
  
)

export default component.exports